import { createSlice } from '@reduxjs/toolkit'

export const colorsSlice = createSlice({
  name: 'colors',
  initialState: {
    aqi_eu: [
      'interpolate',
      ['linear'],
      ['to-number', ['get', 'aqi_eu']],
      1,
      '#559f58',
      2,
      '#a7d35c',
      3,
      '#ecd448',
      4,
      '#f5be41',
      5,
      '#f09235',
      6,
      '#da3322'
    ],
    pm25: [
      'interpolate',
      ['linear'],
      ['to-number', ['get', 'pm25']],
      0,
      '#559f58',
      10,
      '#a7d35c',
      20,
      '#ecd448',
      25,
      '#f09235',
      50,
      '#da3322',
      75,
      '#da3322'
    ],
    pm10: [
      'interpolate',
      ['linear'],
      ['to-number', ['get', 'pm10']],
      0,
      '#559f58',
      20,
      '#a7d35c',
      40,
      '#ecd448',
      50,
      '#f09235',
      100,
      '#f09235',
      150,
      '#da3322'
    ],
    no2: [
      'interpolate',
      ['linear'],
      ['to-number', ['get', 'no2']],
      0,
      '#559f58',
      40,
      '#a7d35c',
      90,
      '#ecd448',
      120,
      '#f09235',
      230,
      '#da3322',
      340,
      '#da3322'
    ],
    o3: [
      'interpolate',
      ['linear'],
      ['to-number', ['get', 'o3']],
      0,
      '#559f58',
      50,
      '#a7d35c',
      100,
      '#ecd448',
      130,
      '#f09235',
      240,
      '#da3322',
      380,
      '#da3322'
    ]
  },
  reducers: {}
})

export default colorsSlice.reducer
